/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-01 10:23:11
 * @LastEditors: Xueran
 * @LastEditTime: 2022-07-13 19:55:21
 */
const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
// 企业列表
export const listEnt = params => request(BASE_URL + '/goventDetail/listEnt', { params })
/** 导出文件*/
// export const  exportEntList = params =>  request.downLoad(BASE_URL + '/entDetail/exportEnt', params)
export function exportEntList(params, downCallBack) {
  return request.downLoad(BASE_URL + '/goventDetail/exportEnt', params, '', '', downCallBack)
}
/** 显示丽水市及各个区县数据 */
export const getArea = params => request(BASE_URL + '/govdictArea/getArea', { params })
/** 所有行业 */
export const getIndustry = params => request(BASE_URL + '/dictIndustry/getIndustry', { params })
/** 所有标签 */
export const getAllDictLabel = params => request(BASE_URL + '/dictLabel/getAllDictLabel', { params })
/** 联系企业 */
export const sendMovenSMS = params => request.post(BASE_URL + '/smsMessage/sendMovenSMS',  params)
/** 所有标签 */
export const getEntDetail = params => request(BASE_URL + '/goventDetail/getEntDetail', { params })
/** 获取企业信息 */
export const getEmployeeInfo = params => request(BASE_URL + '/goventDetail/getEmployeeInfo', { params })
/** 企业互动-工商信息 */
export const getEntOpen = params => request(BASE_URL + '/goventDetail/getEntOpen', { params })
/** 地区 */
export const getAreaList = params => request(BASE_URL + '/govdictArea/getAreaList', { params })
/** 编辑用户信息 */
export const updateEmployeeInfo = params => request.post(BASE_URL + '/goventDetail/updateEmployeeInfo', params)
/** 更新企业信息 */
export const updateEntName = data => request.post(BASE_URL + '/goventDetail/updateEntName', data)
/** 更新备注 */
export const updateEntMark = params => request(BASE_URL + '/goventDetail/updateEntMark', { params })
/** 更新企业信息 */
// 企业账号
export const insertOrUpdateEntDetail = params => request.post(BASE_URL + '/goventDetail/insertOrUpdateEntDetail3',  params)
// 管理账号
export const insertOrUpdateEntDetailByAdmin = params => request.post(BASE_URL + '/goventDetail/insertOrUpdateEntDetail',  params)
/** 企业打标 */
export const insertEntMarking = params => request(BASE_URL + '/dictLabel/insertEntMarking',  { params })
/** 视频文件上传 */
export const uploadVideo = process.env.VUE_APP_BASE_API + BASE_URL + '/api/file/uploadVideo'
/** 无联系人 */
export const isConnectList = params => request(BASE_URL + '/smsMessage/isConnectList',  { params })
/** 获取企业标签结构 */
export const getEntLabel = params => request(BASE_URL + '/goventDetail/getEntLabel', { params })

/** 企业互动-经营信息 */
export const getManagementData = params => request(BASE_URL + '/goventDetail/getManagementData', { params })
/** 企业互动-修改经营信息 */
export const updateManagementData = params => request.post(BASE_URL + '/goventDetail/updateManagementData', params)
/** 企业互动-专利信息 */
export const getPatentData = params => request(BASE_URL + '/goventDetail/getPatentData', { params })
/** 企业互动-修改专利信息 */
export const updatePatentData = params => request.post(BASE_URL + '/goventDetail/updatePatentData', params)
// 企业名单导入模板下载 /goventDetail/downLoadImportTemplate
export function downLoadImportTemplate(params, downCallBack) {
  return request.downLoad(BASE_URL + '/goventDetail/downLoadImportTemplate', params, '', '', downCallBack)
}
// 企业导入 /api/file/uploadFileByContentType
export const importEntInfo = process.env.VUE_APP_BASE_API + BASE_URL + '/goventDetail/importEntInfo'
// 获取导入历史 /lishui-gov/goventDetail/getImportHistoryList
export const getImportHistoryList = params => request(BASE_URL + '/goventDetail/getImportHistoryList', { params })
// 查看失败记录 /lishui-giv/goventDetail/getImportFailList
export const getImportFailList = params => request(BASE_URL + '/goventDetail/getImportFailList', { params })

// 企业风采
export const insertOrUpdateEntStyle = params => request.post(BASE_URL + '/goventDetail/insertOrUpdateEntDetail2',  params)
// 五企培育-列表抬头 // /lishui-gov/serveInst/headerList
export const getHeaderList = params => request(BASE_URL + '/serveInst/headerList',  { params })
// 文件上传 /prod-api/lishui-gov/api/file/upload
export const uploadFile =
  process.env.VUE_APP_BASE_API + BASE_URL + '/api/file/upload'
